import _styled, { default as _styled2 } from "styled-components";
const _excluded = ["displayButton", "message", "userTrials", "onClickAnalytics", "className", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { stylePropType } from '@adsk/alloy-react-theme';
import TrialModal from './components/TrialModal';
import { AUTOSPECS_TRIAL_MARKETING_URL, OFFERINGS_CATEGORIES, PRICING_URL } from './components/TrialModalItem/helpers/const';
import { buttonStyle, containerStyle, messageStyle } from './helpers/styles';
import { bannerMessagePropType, subscriptionPropType } from './helpers/types';
const TrialBannerView = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      displayButton,
      message,
      userTrials,
      onClickAnalytics,
      className,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [show, setShow] = useState(false);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`./i18n/${locale}.json`);
  });
  const handleClickBuyingOptions = () => {
    const justOneTrial = userTrials && userTrials.length === 1;
    if (!justOneTrial) {
      setShow(true);
    } else {
      const buyingOptionsLink = userTrials[0].offeringCategory === OFFERINGS_CATEGORIES.AUTOSPECS ? AUTOSPECS_TRIAL_MARKETING_URL : `${PRICING_URL}/${userTrials[0].offeringCategory}`;
      window.open(buyingOptionsLink, '_blank');
    }
    onClickAnalytics === null || onClickAnalytics === void 0 ? void 0 : onClickAnalytics();
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    className: className,
    ref: ref,
    "data-testid": "TrialBanner"
  }, props, {
    $_css: [containerStyle, style]
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: messageStyle(message ? message.daysLeft : null)
  }, message ? message.text : ''), displayButton && /*#__PURE__*/React.createElement(Button, {
    "data-testid": "TrialBanner_button",
    style: buttonStyle,
    variant: Button.VARIANTS.PRIMARY,
    onClick: handleClickBuyingOptions
  }, T.translate('BANNER_BUTTON_LABEL')), /*#__PURE__*/React.createElement(TrialModal, {
    "data-testid": "TrialBanner_modal",
    onClose: () => {
      setShow(false);
    },
    show: show,
    userTrials: userTrials
  }));
});
TrialBannerView.displayName = 'TrialBannerView';
TrialBannerView.defaultProps = {
  message: null,
  displayButton: false
};
TrialBannerView.propTypes = {
  /** Analytics method to run on open modal */
  onClickAnalytics: PropTypes.func.isRequired,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Display button flag */
  displayButton: PropTypes.bool,
  /**  The message to display  */
  message: bannerMessagePropType,
  /** User Trials data */
  userTrials: PropTypes.arrayOf(subscriptionPropType.isRequired).isRequired,
  /** Styles applied to the root element */
  style: stylePropType
};
export default TrialBannerView;
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  displayName: "TrialBannerView___StyledDiv2",
  componentId: "sc-lkorm8-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=TrialBannerView.js.map